var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-widget"},_vm._l((_vm.heroPostsWidget.items),function(item,index){return _c('div',{key:index,staticClass:"item",style:(_vm.itemBackgroundStyle(item))},[_c('div',[_c('h1',[_c('router-link',{attrs:{"to":{ 
          name: 'post',
          params: { 
            year: _vm.getDateObject(item.post.date).year,
            month: _vm.getDateObject(item.post.date).month,
            day: _vm.getDateObject(item.post.date).day,
            post: item.post.slug
          }
        }}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")])],1),_c('div',{staticClass:"item-description",domProps:{"innerHTML":_vm._s(_vm.parsedDescription(item.description))}})]),_c('CallToAction',{attrs:{"id":item.callToAction.id}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }